import {
  Radio,
  FormLabel,
  RadioGroup,
  RadioProps,
  FormControl,
  useRadioGroup,
  FormHelperText,
  FormControlLabelProps,
  SxProps,
  Theme,
} from '@mui/material';

import { Asterisk } from '@/components/Asterisk';
import { FieldWrapperPassThroughProps } from '@/components/Form/FieldWrapper';
import { Option } from '@/components/Form/SelectField';

import {
  RadioBoxIcon,
  stylesRadioBox,
  RadioBoxCheckedIcon,
  StyledFormControlLabel,
  stylesRadioBoxFromControl,
} from './RadioGroupField.styles';

type RadioGroupFieldProps = FieldWrapperPassThroughProps & {
  name?: string;
  value?: string;
  options: Option[];
  className?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  defaultValue?: string;
  labelSx?: SxProps<Theme>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
};

function RadioBoxFormControlLabel(props: FormControlLabelProps) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    // eslint-disable-next-line react/destructuring-assignment
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

function RadioBox(props: RadioProps) {
  return (
    <Radio
      disableRipple
      color='default'
      checkedIcon={<RadioBoxCheckedIcon />}
      icon={<RadioBoxIcon />}
      sx={stylesRadioBox}
      {...props}
    />
  );
}

export function RadioGroupField(props: RadioGroupFieldProps) {
  const {
    id,
    sx,
    name,
    label,
    error,
    labelSx,
    options,
    isRequired,
    value = '',
    className = '',
    defaultValue = '',
    disabled = false,
    onChange,
  } = props;

  return (
    <FormControl error={!!error} sx={stylesRadioBoxFromControl} disabled={disabled}>
      <FormLabel id={id} sx={labelSx}>
        {label}
        {isRequired ? <Asterisk /> : ''}
      </FormLabel>
      <RadioGroup
        onChange={onChange}
        aria-labelledby={id}
        className={className}
        defaultValue={defaultValue}
        value={value}
        name={name}
        id={id}
        row
      >
        {options.map(({ optLabel, optValue }) => (
          <RadioBoxFormControlLabel
            key={optValue.toString()}
            value={optValue ?? ''}
            control={<RadioBox />}
            label={optLabel}
            sx={{ position: 'relative', ...sx }}
          />
        ))}
      </RadioGroup>
      <FormHelperText>{error?.message}</FormHelperText>
    </FormControl>
  );
}
